import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

// Components
import Header from './components/Header';
import Footer from './components/Footer';
import FAQChatbox from './components/FAQChatbox';

// Pages
import Home from './pages/Home';
import Contact from './pages/Contact';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';

// Styles
import './App.css';
import { colors } from './theme/colors';
import { brand, fonts } from './theme/brand';

// Theme configuration
const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: colors.primary,
    },
    secondary: {
      main: colors.secondary,
    },
    background: {
      default: '#f8fafc',
      paper: '#ffffff',
    },
    text: {
      primary: '#1E293B',
      secondary: '#64748b',
    },
    success: {
      main: colors.success,
    },
    info: {
      main: colors.info,
    },
    warning: {
      main: colors.warning,
    },
    error: {
      main: colors.error,
    },
  },
  typography: {
    fontFamily: fonts.body,
    h1: {
      fontWeight: 700,
      color: colors.text.primary,
    },
    h2: {
      fontWeight: 600,
      color: colors.text.primary,
    },
    h3: {
      fontWeight: 500,
      color: colors.text.primary,
    }
  },
});

// Scroll to the section named in the URL hash (e.g. /#build), or to the top on page change
function ScrollToHash() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}

function App() {
  return (
    <Router>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ScrollToHash />
        <div className="App" style={{ backgroundColor: brand.ink }}>
          <Header />

          <main className="main-content" style={{ paddingTop: '64px', paddingBottom: 0 }}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/home" element={<Home />} />
              <Route path="/services" element={<Navigate to="/#build" replace />} />
              <Route path="/how-we-work" element={<Navigate to="/#process" replace />} />
              <Route path="/about" element={<Navigate to="/#about" replace />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
            </Routes>
          </main>

          <FAQChatbox />
          <Footer />
        </div>
      </ThemeProvider>
    </Router>
  );
}

export default App;
